import { render, staticRenderFns } from "./ListChip.vue?vue&type=template&id=29fae65d&"
import script from "./ListChip.vue?vue&type=script&lang=js&"
export * from "./ListChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports